<template>
	<div class="wrapper position-relative d-flex align-center justify-center fill-height bg-primary-light">
		<div class="outter content-wrapper">
			<div class="content">
				<div class="container-fluid">
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { mapState } from 'vuex';

export default {
	components: {
	},
	computed: {
		// ...mapState(['loading'])
	}
}
</script>